module.exports = {"data":{"site":{"siteMetadata":{"title":"Elesthorp"}},"contentfulAsset":{"file":{"fileName":"elesthorp-gray.svg","url":"//images.contentful.com/gcyy8n8f5ep0/3o8bEoq16MM8YWCSYy66c4/86ccb2e1977d48432018dfcd44278bf8/elesthorp-gray.svg"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 141
// module chunks = 22676092666560 60335399758886